import _ from "lodash";
import TableReportHelper from "report/helper";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

export default async function apontamentoHeaderLocalizacaoReport(
    visita,
    indicador,
    apontamento,
    params,
    optLabelConformidade,
    configIndicador,
    additionalColumn,
    showConformidade = true,
) {
    const h = new TableReportHelper(apontamento);
    const coletas = apontamento?.coletas ?? apontamento.georeferencia;
    const IndicadorClass = indicador.constructor;

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;

    if (_.isEmpty(params)) {
        return h.panel(
            [
                h.row(h.title("Amostra"), h.text(nomeAmostra), h.title("Localizações")),
                h.row(
                    h.title("ATENÇÃO: Não existem parâmetros configurados no cliente para este indicador.", {
                        colSpan: 2,
                    }),
                    await h.locationImageFieldHeaderOnly(coletas),
                ),
            ],
            { widths: [80, "*", 210] },
        );
    }
    const status = IndicadorClass.getConformidadeStatus(
        apontamento.conformidade,
        params.meta,
        apontamento,
        visita.cliente,
    );

    const talhao = h.text(getTalhaoNomeDisplay(apontamento));
    const areaTalhao = h.text(getTalhaoAreaDisplay(apontamento));

    let titleAr = [h.title("Talhão"), h.title("Área (ha)")];
    let valueAr = [talhao, areaTalhao];
    let tamAr = [];

    if (apontamento.variedade) {
        titleAr.push(h.title("Variedade"));
        valueAr.push(h.textField("variedade.variedade"));
    }

    if (apontamento.corte) {
        titleAr.push(h.title("Corte"));
        valueAr.push(h.textField("corte"));
    }

    if (!configIndicador || configIndicador.showTrator) {
        tamAr.push(60);
        titleAr.push(h.title("Trator"));
        valueAr.push(h.textField("trator.numeroFrotaTrator"));
        tamAr.push("*");
    } else {
        tamAr.push("*");
    }

    if (!configIndicador || configIndicador.showImplemento) {
        titleAr.push(h.title("Implemento"));
        valueAr.push(h.textField("implemento.numeroFrotaImplemento"));
        tamAr.push("*");
    }

    if (!configIndicador || configIndicador.showFrente) {
        titleAr.push(h.title("Frente"));
        if (typeof apontamento.frente === "object") {
            valueAr.push(h.textField("frente.frente"));
        } else {
            valueAr.push(h.textField("frente"));
        }
        tamAr.push(125);
    }

    if (!configIndicador || configIndicador.showEquipamento) {
        titleAr.push(h.title("Equipamento"));
        valueAr.push(h.textField("equipamento.equipamento"));
        tamAr.push(125);
    }

    if (configIndicador && configIndicador.addHeaderField) {
        configIndicador.addHeaderField.forEach((nc) => {
            titleAr.push(h.title(nc.label));

            let secConformidade = nc.secondConformidadeField ? nc.secondConformidadeField(apontamento) : false;
            valueAr.push(
                nc.secondConformidadeField
                    ? h.conformidadeField(secConformidade.conformidade, secConformidade.status, secConformidade.config)
                    : nc.valueGetter
                      ? h.text(nc.valueGetter(apontamento))
                      : h.textField(nc.field),
            );

            tamAr.push(nc.width);
        });
    }

    if (additionalColumn) {
        titleAr.push(h.title(additionalColumn.label));
        valueAr.push(h.textField(additionalColumn.field));
        tamAr.push(additionalColumn.width);
    }

    if (showConformidade) {
        titleAr.push(h.title(optLabelConformidade || "Conformidade (%)", {}));
        valueAr.push(h.conformidadeField("conformidade", status, {}));
        tamAr.push(90);
    }

    let valuesArFirstRow = [];
    let tamArFirstRow = [];

    valuesArFirstRow.push(h.title("Amostra"));
    valuesArFirstRow.push(h.text(nomeAmostra));
    tamArFirstRow.push(60);
    tamArFirstRow.push("*");

    valuesArFirstRow.push(h.title("Tipo"));
    valuesArFirstRow.push(h.textField("tipo"));
    tamArFirstRow.push(50);
    tamArFirstRow.push(70);

    if (!configIndicador || configIndicador.showMeta) {
        valuesArFirstRow.push(h.title(`Meta (${IndicadorClass.quantifierMeta || "%"})`));
        valuesArFirstRow.push(h.text(params.meta));
        tamArFirstRow.push(45);
        tamArFirstRow.push(40);
    }

    const arr = titleAr.map((ta, i) => {
        let arr2 = h.row(ta, valueAr[i]);
        return arr2;
    });

    const p1content = [h.row(h.title("Amostra"), h.text(nomeAmostra)), h.row(h.title("Tipo"), h.textField("tipo"))];

    if (!configIndicador || configIndicador.showMeta) {
        p1content.push(h.row(h.title(`Meta (${IndicadorClass.quantifierMeta || "%"})`), h.text(params.meta)));
    }

    const content = [
        h.panel(p1content, { widths: [100, "*"] }),
        // h.panel([h.row(...valuesArFirstRow)], { widths: tamArFirstRow }),

        h.panel(arr, { widths: [100, "*"] }),
    ];

    const panelMapa = h.panel([h.row(h.unbreakable(content), await h.locationImageFieldHeaderOnly(coletas))], {
        widths: ["*", 210],
    });

    return panelMapa;
    // return h.panel(panelMapa);
}
